<template lang="html">
  <div class="mapview" @dragenter="insideMap" @dragover.prevent @dragleave="outsideMap">

    <sidebar-mapview
      class="cardSidebar"
      :groups="groupIds"
      :zoom="mapZoom || initialZoom"
      :center="dragCenter || initialCenter"
    />
    <md-button class="map-button buttonCreate md-primary md-raised" @click="onCreateChapter()" v-show="!createOn">
      Contar história
      <md-tooltip md-direction="bottom">Contar uma história</md-tooltip>
    </md-button>

    <md-button class="md-icon-button md-secondary md-raised map-button geolocate-btn" @click="geolocate()">
      <md-icon>
        my_location
      </md-icon>
      <md-tooltip>Localizar</md-tooltip>
    </md-button>

    <gmap-map
      ref="mapa"
      :options="mapOptions"
      :center="initialCenter"
      :zoom="initialZoom"
      @dragend="loadAgain"
      @maptypeid_changed="saveMapType"
      @center_changed="updateCenter"
      @zoom_changed="updateZoom"
      @idle="callUpdateDelay"
      style="height: 100%;"
      class="mapOptions"
      >

      <new-marker
        v-if="!noMarker && createOn"
        :type="'chapter'"
        :position="newMarkerPos"
      />

      <!-- current groups -->
      <!-- {{log(groups)}} -->
      <div v-if="leveledGroups[0]">
        <markers
          v-for="group in leveledGroups"
          :key="group.id"
          :marker="group"
          :type="'place'"
          :mode="mode"
        ></markers>
      </div>

    </gmap-map>

  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import LogRocket from "logrocket";
import sidebarMapview from "@/components/drawer/sidebarMapview";
import markers from "@/components/drawer/maps/markers";
import newMarker from "@/components/drawer/maps/newMarker";
import loads from "@/assets/js/sharedLoads";
import mapMath from "@/assets/js/mapMath";
import bus from '@/api/bus';

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

let mapUpdater;

export default {
  name: "mapview",
  components: {
    sidebarMapview,
    markers,
    newMarker,
  },
  props: ['createOn'],
  data() {
    return {
      mapOptions: {
        fullscreenControl: false,
        mapTypeControlOptions: {
          position: 3, // TOP_RIGHT
          style: 2
        },
        streetViewControl: true,
        zoomControl: true,
        rotateControl: true,
        clickableIcons: false,
        restriction: {
          latLngBounds: {
            north: 85,
            south: -85,
            east: 200, // TODO work on longitudinal boundaries
            west: -200
          },
          strictBounds: true
        }
      },
      center: { lat: -15.7663595475, lng: -47.8787606475 },
      groupIds: [],
      groups: [],
      currentGroup: null, // para manipulacao de groups
      mapCenter: null,
      oldCenter: { lat: 0, lng: 0},
      dragCenter: null,
      mapZoom: null,
      oldZoom: null,
      mapObj: {
        center: false,
        zoom: false
      },
      noMarker: true,
      newMarkerPos: null,
      dropOk: false
    };
  },
  computed: {
    google: gmapApi,
    initialZoom() {
      let center = JSON.parse(localStorage.getItem("homeCenter"));
      let zoom = center && center.zoom || this.$route.query.zoom;
      return Number(zoom) || 4;
    },
    initialCenter() {
      let center = JSON.parse(localStorage.getItem("homeCenter"));
      let lat = center && center.lat || this.$route.query.lat;
      let lng = center && center.lng || this.$route.query.lng;
      return {
        lat: Number(lat) || -16.480756765004827,
        lng: Number(lng) || -53.481228516447686
      }
    },
    mode() {
      return this.createOn? 'select' : 'link'
    },
    leveledGroups() {
      let z = this.mapZoom || this.initialZoom;
      return this.groups.filter(group => {
        return [z - 2, z - 1, z, z + 1].indexOf(group.zoom) >= 0;
      });
    }
  },

  mounted() {
    this.$refs.mapa.$mapPromise.then(map => {
      this.mapObj = map;
      this.updateCenter(map.center);
      this.mapZoom = map.zoom;
      this.oldZoom = map.zoom;
      map.setMapTypeId(localStorage.getItem('mapType') || 'hybrid');
      JSON.parse(localStorage.getItem("homeCenter")) && this.geolocate();
      this.loadGroups(this.initialCenter, this.initialZoom);
    });
    bus.on.zoomIn((position, zoom) => {
      this.zoomIn(position, zoom);
    });
    bus.on.place(group => this.currentGroup = group);
    bus.on.clearPlace(() => this.currentGroup = null);
    bus.on.createMarker(event => this.createMarker(event));
    bus.on.createFromSidebar(() => this.onCreateChapter());
  },

  methods: {
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.zoomIn(
          (this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }), 17
        );
      });
      return this.center;
    },
    onCreateChapter() {
      this.$emit('createChapter');
      bus.emit.mapZoom(this.mapZoom || this.initialZoom);
      this.$route.params.position = this.mapCenter;
      this.$route.params.zoom = this.mapZoom;
    },
    updateZoom(zoom) {
      this.oldZoom = this.mapZoom;
      this.mapZoom = zoom;
      mapMath.zoomGroupChanged(this.oldZoom + zoom) ? this.loadAgain() : true || this.updateQuery();
      if(this.createOn)
        bus.emit.mapZoom(zoom);
    },
    updateCenter(center) {
      this.mapCenter = {
        lat: center.lat(),
        lng: center.lng()
      };
      bus.emit.mapCenter(this.mapCenter);
    },
    updateQuery() {
      let query = { lat: this.mapCenter.lat, lng: this.mapCenter.lng, zoom: this.mapZoom || this.initialZoom }
      localStorage.setItem('homeCenter', JSON.stringify(query));
    },
    callUpdateDelay() {
      clearTimeout(mapUpdater);
      mapUpdater = setTimeout(() => {
          this.updateQuery()
      }, 1000);
    },
    loadAgain() {
      // console.log(this.mapCenter);
      this.dragCenter = this.mapCenter;
      let distance = mapMath.distanceFromPosition(this.mapCenter, this.oldCenter);
      let zoom = this.mapZoom || this.initialZoom;
      // let zoomDistance = mapMath.zoomToDistanceS(zoom);
      // this.log('info:', distance, zoomDistance);
      // this.log(distance);
      // this.log(zoomDistance);
      // this.log(distanceInMeters(zoomDistance));
      if (distance > mapMath.minZoomToDistance(zoom) / 2 || mapMath.zoomGroupChanged(this.oldZoom + zoom)){
        // this.log('new load? yes!');
        // this.log(zoom, this.mapCenter);
        this.updateQuery();
        // this.log(zoomDistance);
        // this.log(distanceInMeters(zoomDistance));
        this.loadGroups(this.mapCenter, zoom);
        // set old center after loading data:
        this.oldCenter = this.mapCenter;
      }
      // else this.log('new load? no...')
    },
    loadGroups(center, zoom) {
      loads.loadPlaces(center, zoom)
      .then(groups => {
        this.groups = groups;
        return this.groupIds = groups.map(g => g['id']);
      })
      .catch(error => {
        log(error, "loadGroups(center, zoom)", null);
        return this.log(error);
      });
    },
    panTo: function(position) {
      this.mapObj && typeof this.mapObj.panTo == "function" && this.mapObj.panTo(position);
      // console.log("map", this.mapObj); // eslint-disable-line no-console
    },
    saveMapType(mapType) {
      localStorage.setItem('mapType', mapType);
    },
    zoomIn: function(pos, zoom = null) {
      if(zoom == null)
        zoom = this.mapObj.getZoom() + 1;
      this.mapObj && typeof this.mapObj.setZoom == "function" && this.mapObj.setZoom(zoom);
      this.panTo(pos);
    },
    insideMap(e) {
      e.dataTransfer.dropEffect = "copy";
      // e.target.style.cursor = "crosshair";
      this.dropOk = true;
      // console.log(e);
    },
    outsideMap(e) {
      if (e.fromElement)
        this.dropOk = false;
    },
    createMarker(event) {
      // console.log(this.dropOk);
      if (this.dropOk) {
        bus.emit.position(
          this.newMarkerPos = this.point2LatLng({
            x: event.x - 10,
            y: event.y - 50
          }, this.mapObj)
        )
        this.noMarker = false;
        this.dropOk = false;
      }
    },
    point2LatLng(point, map) {
      let topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
      let bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
      let scale = Math.pow(2, map.getZoom());
      let worldPoint = new this.google.maps.Point(point.x / scale + bottomLeft.x, point.y / scale + topRight.y);
      let latLng = map.getProjection().fromPointToLatLng(worldPoint);
      return { lat: latLng.lat(), lng: latLng.lng() };
    },
    log: function(e) {
      console.log(e); // eslint-disable-line no-console
    }
  }
};
</script>

<style scoped>

.mapview {
  position: relative;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

.buttonCreate {
  right: 50%;
  margin: 1em;
  transform: translateX(50%);
}

.map-button {
  position: absolute;
  z-index: 1;
}

.geolocate-btn {
  right: 4.5px;
  bottom: 200px;
}

.cardSidebar {
  display: flex;
  position: absolute;
  height: 95%;
}

.newMarker:after {
  width: 32px;
  height: 32px;
  display: block;
  content: ' ';
  position: absolute;
  top: 50%; left: 50%;
  margin: -32px 0 0 -16px;
  background: url('https://maps.google.com/mapfiles/ms/icons/green-dot.png');
  pointer-events: none;
}

@media (max-width:451px) {

  .mapOptions >>> div.gmnoprint{
    top: 0;
    bottom: auto!important;
  }

  .mapOptions >>> div.gm-bundled-control{
    left: 0!important;
  }

  .mapOptions >>>.gm-style .gm-svpc{
    border-radius: 12px!important;
  }

  .mapOptions >>> div.gmnoprint.gm-style-cc{
    top: 0;
  }

  .mapOptions >>> div.gm-style-cc{
    top: 0;
  }

  .mapOptions >>> .gmnoprint:first-child{
    display: none;
  }

  .mapOptions >>> div.gm-style-mtc{
    margin: 18px!important;
  }

  .cardSidebar {
    width: 100%;
  }

  .geolocate-btn {
    bottom: 6px;
  }
}

</style>
